import React, { useEffect, useRef, useState } from 'react';
import { preloadAssets } from '../../utils/AddressableManager';

export const asteroidAssets = Array.from(
  { length: 10 },
  (_, i) => ({
    type: 'geometry',
    key: `asteroid_${i}`,
    // radius, detail(0=20 angular faces, 1=80), deformation, seed
    url: `asteroid:0.018,0,0.15,${i + 1}`,
  })
);

export default function AsteroidPreloader({ onComplete, onProgress }) {
  const hasPreloaded = useRef(false);

  useEffect(() => {
    if (hasPreloaded.current) return;
    hasPreloaded.current = true;

    const mainAssetsToLoad = [...asteroidAssets];

    let totalAssets = mainAssetsToLoad.length;
    let loadedCount = 0;

    const handleProgress = () => {
      loadedCount++;
      const progress = Math.round((loadedCount / totalAssets) * 100);
      if (typeof onProgress === 'function') onProgress(progress);
    };

    // Load main assets with progress tracking
    preloadAssets(mainAssetsToLoad, handleProgress)
      .then((loadedAssets) => {
        const normalizedAssets = {};
        for (const [key, value] of Object.entries(loadedAssets)) {
          normalizedAssets[key.toLowerCase()] = value;
        }
        if (typeof onComplete === 'function') onComplete(normalizedAssets);
      })
      .catch((err) => {
        console.error('Error preloading assets:', err);
      });

  }, [onComplete, onProgress]);

  return null;
}